import { CouponDurationUnit, CoverageWithPricesInfo } from '@enaratech/funnel-helper';

export function displayDiscountMessage(
  coverage: CoverageWithPricesInfo | null,
  selectedDuration?: CouponDurationUnit
): string {
  if (!coverage?.coupon) {
    return '';
  }

  const { duration } = coverage.coupon;
  const { discountsApplied } = coverage;

  if (selectedDuration === CouponDurationUnit.Monthly) {
    if (duration.unit === CouponDurationUnit.Lifetime) {
      return `You just saved $${discountsApplied.monthly} on every month of your membership!`;
    }

    if (duration.value === 1) {
      return `You just saved $${discountsApplied.monthly} off your first month! Each month after that will be at the $${coverage.originalPrices.monthly}/month price`;
    }

    return `You just saved $${discountsApplied.monthly} off your first ${duration.value} months! Each month after that will be at the $${coverage.originalPrices.monthly}/month price`;
  } else {
    const { annual, additionalAnnual } = discountsApplied;
    const annualPriceWithAllDiscounts = annual + additionalAnnual;

    return `You just saved $${annualPriceWithAllDiscounts} off your yearly price!`;
  }
}
